module.exports = __webpack_public_path__ + "img/Gif2.f966a2bb.gif";